import { useMemo } from "react";
import { useParams, useLocation } from "wouter";
import { useClients } from "@/hooks/use-clients";
import { useTechnicians } from "@/hooks/use-profiles";
import { ClientDetailContent } from "./detail-content";
import { consumeCameFromList } from "./navigation-state";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

export default function ClientDetail() {
  const { id } = useParams<{ id: string }>();
  const [, setLocation] = useLocation();
  const { data: clients, isLoading } = useClients();
  const { data: techniciansList } = useTechnicians();
  const technicians = techniciansList || [];

  const client = useMemo(
    () => clients?.find((c: { id: string }) => c.id === id) ?? null,
    [clients, id]
  );

  const handleBack = () => {
    if (consumeCameFromList()) {
      window.history.back();
    } else {
      setLocation("/clients");
    }
  };

  if (isLoading) {
    return (
      <div className="max-w-4xl mx-auto p-6 space-y-4 animate-pulse">
        <div className="h-8 w-32 bg-muted rounded" />
        <div className="h-6 w-64 bg-muted rounded" />
        <div className="h-4 w-full bg-muted rounded" />
        <div className="h-4 w-3/4 bg-muted rounded" />
        <div className="h-4 w-1/2 bg-muted rounded" />
        <div className="h-4 w-2/3 bg-muted rounded" />
      </div>
    );
  }

  if (!client) {
    return (
      <div className="flex flex-col items-center justify-center py-24 gap-4">
        <p className="text-muted-foreground text-sm">Client introuvable.</p>
        <Button
          variant="outline"
          size="sm"
          onClick={() => setLocation("/clients")}
          data-testid="btn-back-client-not-found"
        >
          <ArrowLeft className="h-4 w-4 mr-1" /> Retour à la liste
        </Button>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="mb-4">
        <Button
          variant="ghost"
          size="sm"
          onClick={handleBack}
          data-testid="btn-back-client-detail"
        >
          <ArrowLeft className="h-4 w-4 mr-1" /> Retour
        </Button>
      </div>
      <ClientDetailContent client={client} technicians={technicians} />
    </div>
  );
}
